var render = function render(){
  var _class;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "d-inline-block"
  }, [_vm.loading ? _c('div', [_c('SkeletonLoader', {
    staticStyle: {
      "width": "80px",
      "height": "40px"
    }
  })], 1) : _c('div', _vm._g(_vm._b({
    staticClass: "d-inline-block",
    class: (_class = {}, _class[_vm.$style.selector] = true, _class[_vm.$style.active] = _vm.active, _class),
    attrs: {
      "data-base-selector": ""
    }
  }, 'div', _vm.$attrs, false), _vm.$listeners), [_c('p', {
    staticClass: "button-text"
  }, [_vm._t("default")], 2)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }